import { render, staticRenderFns } from "./teamMembers.vue?vue&type=template&id=1606616b&scoped=true&"
import script from "./teamMembers.vue?vue&type=script&lang=js&"
export * from "./teamMembers.vue?vue&type=script&lang=js&"
import style0 from "./teamMembers.vue?vue&type=style&index=0&id=1606616b&prod&scoped=true&lang=css&"
import style1 from "./teamMembers.vue?vue&type=style&index=1&id=1606616b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1606616b",
  null
  
)

export default component.exports